
import MarketplaceForProsStoreName from '@/store/marketplace-for-pros/name';
import InfoBox from './info-box';
import MarketplaceForProsSection from '../section';

export default {
  name: 'SellYourHomeHeroSection',
  components: {
    InfoBox,
    MarketplaceForProsSection,
  },
  computed: {
    content() {
      return this.$store.state[MarketplaceForProsStoreName].heroContent;
    },
  },
};
